var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubscriptionSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 144,
    viewBox: "0 0 145 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 72.5,
    cy: 72,
    r: 72,
    fill: "#27AE60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.298 43.6665C94.903 43.6665 101.335 50.4098 101.335 60.4398V83.591C101.335 93.5898 94.903 100.333 85.298 100.333H60.733C51.128 100.333 44.668 93.5898 44.668 83.591V60.4398C44.668 50.4098 51.128 43.6665 60.733 43.6665H85.298ZM84.8446 63.4998C83.8813 62.5365 82.2946 62.5365 81.3313 63.4998L69.6296 75.2015L64.6713 70.2432C63.708 69.2798 62.1213 69.2798 61.158 70.2432C60.1946 71.2065 60.1946 72.7648 61.158 73.7565L67.9013 80.4715C68.383 80.9532 69.0063 81.1798 69.6296 81.1798C70.2813 81.1798 70.9046 80.9532 71.3863 80.4715L84.8446 67.0132C85.808 66.0498 85.808 64.4915 84.8446 63.4998Z",
    fill: "#27AE60"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionSuccess);
export default __webpack_public_path__ + "static/media/subscriptionSuccess.c72a660c63b9078f36d753f3850675c0.svg";
export { ForwardRef as ReactComponent };